import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import { PageLoadingSkeleton, type LoadingLayout } from "./PageLoadingSkeleton";

export function loadingLayoutForPath(pathname: string): LoadingLayout {
  if (pathname === "/") return "cards";
  if (/^\/(?:login|signup|onboarding|mobile-upload|mu)(?:\/|$)/.test(pathname)) return "form";
  if (pathname === "/privacy" || /^\/s\/(?:customer-share|proposal)\//.test(pathname)) return "detail";
  if (pathname.endsWith("/storage") || pathname === "/platform/pricing") return "table";
  if (/^\/(?:e|s)\//.test(pathname)) return "gallery";
  if (/\/(?:new|edit)$/.test(pathname) || /\/(?:settings|business-profile|generation|quick-generation|studio|pricing|runtime-policies)(?:\/|$)/.test(pathname)) return "form";
  if (/\/(?:customers|leads|outputs|ai-runs|customer-proposals|product-catalogs|brands)\/[^/]+$/.test(pathname)) return "detail";
  if (pathname.endsWith("/outputs")) return "gallery";
  if (/\/(?:showcase|products)$/.test(pathname)) return pathname.startsWith("/m/") ? "gallery" : "table";
  return pathname.startsWith("/m/") ? "rows" : "table";
}

export function RouteLoadingFallback() {
  const { t } = useTranslation("common");
  const { pathname } = useLocation();
  // 面向客户的公开页（展厅 /e/、分享 /s/）不能出现后台的「工作区」措辞
  const isPublicSurface = pathname.startsWith("/e/") || pathname.startsWith("/s/");
  return (
    <main className="spa-shell">
      <PageLoadingSkeleton layout={loadingLayoutForPath(pathname)} heading label={t(isPublicSurface ? "routeLoading.public" : "routeLoading.workspace")} />
    </main>
  );
}
